import { PaginationParams } from '@/types'

export function buildBasePagination(
  pagination?: PaginationParams,
): PaginationParams | undefined {
  if (!pagination) return undefined

  const { key: _unusedKey, ...rest } = pagination
  return rest
}

export function buildPaginationParams(
  pagination?: PaginationParams,
): Record<string, unknown> | undefined {
  if (!pagination) return undefined

  return {
    'pagination.key': pagination.key,
    'pagination.offset': pagination.offset,
    'pagination.limit': pagination.limit,
    'pagination.count_total': pagination.count_total,
    'pagination.reverse': pagination.reverse,
  }
}
